// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions"; // Importa Firebase Functions
import { getStorage } from "firebase/storage";

// Configuración de Firebase proporcionada por el usuario
const firebaseConfig = {
  apiKey: "AIzaSyA2GWykQwYIL_XTrbw8fk7ZyHxLps8ikbY",
  authDomain: "nat-spa.firebaseapp.com",
  projectId: "nat-spa",
  storageBucket: "nat-spa.firebasestorage.app",
  messagingSenderId: "1076180401918",
  appId: "1:1076180401918:web:583d17b847ac2275fa2faf",
  measurementId: "G-2HKG8VM0LX"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// Inicializa Firestore, Auth, Analytics y Functions
const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);
const functions = getFunctions(app); // Inicializa Firebase Functions
const storage = getStorage(app);

// Exporta los servicios de Firebase
export { db, auth, analytics, functions, storage,firebaseConfig };
